/**
 * Created by Ning Jiang on 2021-11-29.
 */
import {Emitter, AnimatedParticle} from "pixi-particles";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ParticlesManager} from "../../../../core/particles/ParticlesManager";
import {TombstoneRip} from "../../../TombstoneRip";

export class BigWinParticles extends PIXI.Container {

    private readonly _screenHeightRange:[number, number] = [720, 1760];
    private readonly _startSpeedRange:[number, number] = [650, 950];

    private readonly _burstConfig:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.4,
            "end" : 0.6,
            "minimumScaleMultiplier" : 0.8
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 900,
            "end" : 450,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 3000
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 260,
            "max" : 280
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -400,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "normal",
        "frequency" : 0.02,
        "emitterLifetime" : 0.6,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -5,
            "y" : 0,
            "w" : 10,
            "h" : 1
        }
    };
    private readonly _particleConfigs:any[][] = [
        // all the same, change frequency in constructor.
        [
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            }
        ],
        [
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            },
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            }
        ],
        [
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            },
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            }
        ],
        [
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            },
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            },
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            }
        ],
        [
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            },
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            },
            {
                "alpha" : {
                    "start" : 1,
                    "end" : 1
                },
                "scale" : {
                    "start" : 0.4,
                    "end" : 0.6,
                    "minimumScaleMultiplier" : 0.8
                },
                "color" : {
                    "start" : "#ffffff",
                    "end" : "#ffffff"
                },
                "speed" : {
                    "start" : 700,
                    "end" : 450,
                    "minimumSpeedMultiplier" : 2
                },
                "acceleration" : {
                    "x" : 0,
                    "y" : 2000
                },
                "maxSpeed" : 0,
                "startRotation" : {
                    "min" : 240,
                    "max" : 300
                },
                "noRotation" : false,
                "rotationSpeed" : {
                    "min" : -400,
                    "max" : 400
                },
                "lifetime" : {
                    "min" : 2,
                    "max" : 2
                },
                "blendMode" : "normal",
                "frequency" : 0.1,
                "emitterLifetime" : -1,
                "maxParticles" : 200,
                "pos" : {
                    "x" : 0,
                    "y" : 0,
                },
                "addAtBack" : false,
                "spawnType" : "rect",
                "spawnRect" : {
                    "x" : -25,
                    "y" : 0,
                    "w" : 50,
                    "h" : 1
                }
            }
        ]
    ];
    private _particleTextures = [
        ["bigwin/particles/woodA/wA_", "bigwin/particles/woodB/wB_",
            "bigwin/particles/w1", "bigwin/particles/w2", "bigwin/particles/w3",
            "bigwin/particles/w4", "bigwin/particles/w5", "bigwin/particles/w6",
            "bigwin/particles/w7", "bigwin/particles/w8", "bigwin/particles/w9"],
        ["bigwin/particles/stone/stone_"],
        ["bigwin/particles/p1", "bigwin/particles/p2", "bigwin/particles/p3",
            "bigwin/particles/p4", "bigwin/particles/p5", "bigwin/particles/p6"]
    ];

    private _particleEmitters:Emitter[][] = [[], [], [], [], []];
    private _burstEmitters:Emitter[] = [];
    private _currentLevel:number = -1;

    constructor() {
        super();
        this._particleConfigs[0][0].frequency = 0.1;
        this._particleConfigs[1][0].frequency = 0.1;
        this._particleConfigs[1][1].frequency = 0.14;
        this._particleConfigs[2][0].frequency = 0.12;
        this._particleConfigs[2][1].frequency = 0.1;
        this._particleConfigs[3][0].frequency = 0.13;
        this._particleConfigs[3][1].frequency = 0.11;
        this._particleConfigs[3][2].frequency = 0.1;
        this._particleConfigs[4][0].frequency = 0.3;
        this._particleConfigs[4][1].frequency = 0.2;
        this._particleConfigs[4][2].frequency = 0.08;
    }

    public play(level:number):void {
        this.stop();
        this._currentLevel = level;

        // forEach config and check if emitter exist. create and play.
        this._particleConfigs[level].forEach((config, i) => {
            if(!this._particleEmitters[level][i]) {
                const emitter = new Emitter(this, this.getEmitterParticles(i).map(path => {
                    return {
                        framerate : 30,
                        loop : true,
                        hasLoaded : true,
                        textures : TombstoneRip.assetLoader.getTextures(path)
                    }
                }), config);
                emitter.particleConstructor = AnimatedParticle;
                ParticlesManager.addEmitter(emitter, false);
                this._particleEmitters[level][i] = emitter;
            }
            this._particleEmitters[level][i].emit = true;
        });


        if(!this._burstEmitters[level]) {
            const emitter = new Emitter(this, this.getBurstEmitterParticles(level).map(path => {
                return {
                    framerate : 30,
                    loop : true,
                    hasLoaded : true,
                    textures : TombstoneRip.assetLoader.getTextures(path)
                }
            }), this._burstConfig);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._burstEmitters[level] = emitter;
        }
        this._burstEmitters[level].emit = true;
    }

    private getEmitterParticles(index:number):string[] {
        switch(index) {
            case 2:
                return this._particleTextures[2].concat();
            case 1:
                return this._particleTextures[1].concat();
            case 0:
            default:
                return this._particleTextures[0].concat();
        }
    }

    private getBurstEmitterParticles(level:number):string[] {
        switch(level) {
            case 4:
            case 3:
                return this._particleTextures[1].concat(this._particleTextures[2]);
            case 2:
            case 1:
                return this._particleTextures[0].concat(this._particleTextures[1]);
            case 0:
            default:
                return this._particleTextures[0].concat();
        }
    }

    public resize():void {
        // remove existing emitters.
        this._particleEmitters.forEach(levelEmitters => {
            levelEmitters.forEach(emitter => {
                if(emitter) {
                    ParticlesManager.removeEmitter(emitter, true);
                }
            });
        });
        this._particleEmitters = [[], [], [], [], []];
        this._burstEmitters.forEach(emitter => {
            if(emitter) {
                ParticlesManager.removeEmitter(emitter, true);
            }
        });
        this._burstEmitters = [];

        // resize configs.
        let screenHeight:number = NolimitApplication.screenBounds.height;
        let screenHeightInRange:number = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1])) - 200;
        const startSpeed:number = Math.ceil((screenHeightInRange - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);
        this._particleConfigs.forEach(levelConfigs => {
            levelConfigs.forEach((config:{ speed:{ start:number, end:number }, pos:{ y:number } }, level:number) => {
                const levelSpeed:number = startSpeed * (1 + 0.2 * level);
                config.speed.start = levelSpeed;
                config.speed.end = levelSpeed;
            });
        });
        const burstSpeed:number = 1.8 * startSpeed;
        this._burstConfig.speed.start = burstSpeed;
        this._burstConfig.speed.end = burstSpeed;
        this.position.set(0, NolimitApplication.screenBounds.height * 0.5 + 100);

        if(this._currentLevel > -1) {
            this.play(this._currentLevel);
        }
    }

    public stop():void {
        this._currentLevel = -1;
        this._particleEmitters.forEach((levelEmitters:Emitter[]) => {
            levelEmitters.forEach(emitter => {
                if(emitter) {
                    emitter.emit = false;
                }
            });
        })
        this._burstEmitters.forEach(emitter => {
            if(emitter) {
                emitter.emit = false;
            }
        });
    }
}